const initialState = {
  read: [],
  unread: [],
  flyoutIsOpen: false,
}

export default function (state = initialState) {
  return state
}
